import * as a from "react";
import { u as r } from "./index-Dn5fq5RO.js";
var s = a.useId || (() => {
}), f = 0;
function c(t) {
  const [u, e] = a.useState(s());
  return r(() => {
    t || e((o) => o ?? String(f++));
  }, [t]), t || (u ? `radix-${u}` : "");
}
export {
  c as u
};
